import Flickity from 'flickity'
import isNull from 'lodash/isNull'
import ProductImagery from './ProductImagery'

export default class ProductSlider {
    constructor() {
        this.cacheDom()
        this.initialize()
        this.bindEvents()
        this.storeGalleryThumbnails()
    }

    cacheDom() {
        this.imagery = new ProductImagery()
        this.flkty = null
        this.featuredImage = document.querySelector('.product-featured-image img').dataset.imagesrc
        this.variantImages = document.querySelector('.product-variant-images')
        this.variantSlider = document.querySelector('.product-variant-slider')
        this.variantSliderControls = document.querySelector('.product-variant-slider-controls')
        this.variantNextArrow = document.querySelector('.product-variant-slider-controls .product-slider-arrows.next')
        this.variantPrevArrow = document.querySelector('.product-variant-slider-controls .product-slider-arrows.prev')
        this.coverageCalculator = document.getElementById('coverage-calculator')
        this.coverageTrigger = document.querySelector('.coverage-trigger')
        this.cartForm = document.getElementById('cart-form')
        this.galleryThumbnails = document.querySelector('.product-gallery-thumbnails')
    }

    initialize() {
        if (!isNull(this.variantSlider)) {
            this.flktyVariants = new Flickity(this.variantSlider, {
                draggable: false,
                cellAlign: 'left',
                prevNextButtons: false,
                pageDots: false,
                wrapAround: false,
            })
        }

        this.checkVariant()
    }

    bindEvents() {
        if (!isNull(this.variantNextArrow)) {
            this.variantNextArrow.addEventListener('click', () => {
                this.flktyVariants.next(true, false)
            })

            this.variantPrevArrow.addEventListener('click', () => {
                this.flktyVariants.previous(true, false)
            })
        }

        if (!isNull(this.coverageTrigger)) {
            this.coverageTrigger.addEventListener('click', this.handleCoverageTriggerClick.bind(this))
        }

        this.cartForm.addEventListener('change', this.checkVariant.bind(this))
    }

    handleCoverageTriggerClick(event) {
        event.preventDefault()
        const scrollDiv = this.coverageCalculator.offsetTop - 200
        window.scrollTo({ top: scrollDiv, behavior: 'smooth' })
    }

    checkVariant() {
        const currentVariation = document.querySelector('input[name="id"]')
        
        if (isNull(this.variantImages)) {
            return
        }

        if (isNull(currentVariation) || !currentVariation.value) {
            this.hideVariantSlider()
            return
        }
        
        const variantId = currentVariation.value
        const sliderVariationImages = document.querySelectorAll('.product-variant-images img[data-variant="' + variantId + '"]')

        if (sliderVariationImages.length) {
            this.showVariantSlider(sliderVariationImages)
        } else {
            this.hideVariantSlider()
        }
    }

    showVariantSlider(images) {
        const slides = document.querySelectorAll('.product-slider-slide')
        const galleryThumbnails = document.querySelector('.product-gallery-thumbnails ul')
        let slide = null
        let columns = null

        // Update featured image
        this.imagery.updateFeaturedMedia(images[0].getAttribute('data-imagesrc'))

        // Change displays
        this.variantSlider.style.display = 'block'

        // Empty gallery thumbnails
        galleryThumbnails.innerHTML = ''

        // Move current variant images back into vault
        slides.forEach((slide) => {
            this.flktyVariants.remove(slide)
        })

        // Add featured image to gallery thumbnails
        const featuredImage = images[0]
        featuredImage.src = featuredImage.getAttribute('data-thumbnail')
        featuredImage.setAttribute('data-index', 0)
        galleryThumbnails.insertAdjacentHTML('beforeend', '<li><figure>' + featuredImage.outerHTML + '</figure></li>')

        // Slice images, excluding first
        const remainingImages = Array.prototype.slice.call(images, 1)

        // Create DOM markup for selected variant images
        remainingImages.forEach((image, index) => {
            const everyFourth = (index + 1) % 4
            const everyOnePastFourth = index % 4
            
            // Load src and add index
            image.src = image.getAttribute('data-thumbnail')
            image.setAttribute('data-index', index + 1)
            
            // Add slider containers
            if (index === 0 || everyOnePastFourth === 0) {
                slide = document.createElement('div')
                columns = document.createElement('div')

                // Add Class
                slide.classList.add('product-slider-slide')
                columns.classList.add('columns', 'is-multiline', 'is-mobile', 'is-variable', 'is-1-mobile', 'is-6-desktop')

                // Nest columns into slide
                slide.append(columns)
            }

            // Add Image
            if (columns) {
                const column = document.createElement('div')
                const slideImage = document.createElement('div')

                // Add Class
                column.classList.add('column', 'is-3-mobile', 'is-6-tablet', 'is-6-desktop')
                slideImage.classList.add('product-slider-slide-image')

                // Nest slide image into column
                column.append(slideImage)
                slideImage.append(image.cloneNode())

                // Nest column into columns
                columns.append(column)
            }

            if (slide) {
                // Append slide to slider
                this.flktyVariants.append(slide)
                this.flktyVariants.reloadCells()
            }

            // Add closing container tags
            if (everyFourth === 0) {
                slide = null
                columns = null
            }

            // Add image to gallery thumbnails
            galleryThumbnails.insertAdjacentHTML('beforeend', '<li><figure>' + image.outerHTML + '</figure></li>')
        })

        // Enable controls
        if (remainingImages.length <= 4) {
            this.variantSliderControls.style.display = 'none'
        } else {
            this.variantSliderControls.style.display = 'flex'
        }
    }

    hideVariantSlider() {
        this.variantSlider.style.display = 'none'
        this.variantSliderControls.style.display = 'none'

        // Update featured image
        this.imagery.updateFeaturedMedia(this.featuredImage)

        this.resetGalleryThumbnails()
    }

    storeGalleryThumbnails() {
        if (isNull(this.galleryThumbnails)) {
            return
        }

        this.galleryThumbnails = this.galleryThumbnails.innerHTML
    }

    resetGalleryThumbnails() {
        const thumbnails = document.querySelector('.product-gallery-thumbnails')
        thumbnails.innerHTML = this.galleryThumbnails
    }
}
